const teamData = {
  staffs: [
    {
      name: "Isaac Wiafe",
      title: "Associate Professor of Information Technology & Lab Director",
      image: `${process.env.PUBLIC_URL}/prof.jpg`,
      description: [
        "- Systems Analysis & Design",
        "- Large Language Modelling",
        "- Persuasive Technologies",
        "- IT for Behaviour Change",
        "- Extended Reality",
      ],
      about:
        "Professor Isaac Wiafe is a distinguished scholar whose pioneering research focuses on the intersection of technology and human behavior, particularly in the areas of virtual reality and persuasive technologies. He is recognized for his innovative studies on how these technologies, designed to change attitudes or behaviors, can promote healthier lifestyles, enhance learning outcomes, and encourage sustainable practices. By leveraging immersive virtual environments and intelligent systems, he creates engaging experiences that drive meaningful behavioral changes.",
    },
    {
      name: "Jamal-Deen Abdulai",
      title: "Associate Professor",
      image: `${process.env.PUBLIC_URL}/prof_jamal.jpg`,
      description: [
        "- Wireless Communication Systems",
        "- AI and Machine Learning",
        "- Computer Networking",
        "- Sensor Networks",
        "- Photonics",
      ],
      about:
        "Professor Jamal-Deen is a distinguished scholar whose pioneering research focuses on the intersection of wireless networks and artificial intelligence, particularly in the areas of virtual reality and persuasive technologies. He is recognized for his innovative studies on how these technologies, designed to change attitudes or behaviors, can promote healthier lifestyles, enhance learning outcomes, and encourage sustainable practices. By leveraging immersive virtual environments and intelligent systems, he creates engaging experiences that drive meaningful behavioral changes.",
    },
  ],
  team: [
    {
      name: "Akon Ekpezu",
      title: "Research Assistant, PhD Student",
      image: `${process.env.PUBLIC_URL}/akon.jpg`,
      expertise:
        "Persuasive Technologies, Natural Language Processing, Automatic Speech Recognition, Large Language Models",
      status: "current",
    },
    {
      name: "Mark Atta Mensah",
      title: "Research Assistant, PhD Student",
      image: `${process.env.PUBLIC_URL}/mark.jpeg`,
      expertise:
        "Persuasive Technologies, Natural Language Processing, Automatic Speech Recognition, Large Language Models",
      status: "current",
    },
    {
      name: "Elikem Doe Atsapo",
      title: "Research Assistant, PhD Student",
      image: `${process.env.PUBLIC_URL}/elikem.jpeg`,
      expertise:
        "Virtual Reality, Automatic Speech Recognition, Natural Language Processing",
      status: "past",
    },
    {
      name: "Charles Nutrokpor",
      title: "Research Assistant, MPhil Student",
      image: `${process.env.PUBLIC_URL}/`,
      expertise:
        "Virtual Reality, Automatic Speech Recognition, Natural Language Processing",
      status: "past",
    },
    {
      name: "Raynard ",
      title: "Research Assistant, MPhil Student",
      image: `${process.env.PUBLIC_URL}/`,
      expertise:
        "Virtual Reality, Automatic Speech Recognition, Natural Language Processing",
      status: "past",
    },
    {
      name: "Sumaya Salihs Ahmed",
      title: "Research Assistant, MSc Student",
      image: `${process.env.PUBLIC_URL}/sumaya.jpeg`,
      expertise:
        "Automatic Speech Recognition, Natural Language Processing, Large Language Models",
      status: "current",
    },
    {
      name: "Akosua Nyarkoa Wiafe-Akenteng",
      title: "Research Assistant, MSc Student",
      image: `${process.env.PUBLIC_URL}/akosua.jpeg`,
      expertise:
        "Automatic Speech Recognition, Natural Language Processing, Large Language Models",
      status: "current",
    },
    {
      name: "Evans Kwasi",
      title: "Research Assistant, MSc Student",
      image: `${process.env.PUBLIC_URL}/evans.jpeg`,
      expertise:
        "Automatic Speech Recognition, Natural Language Processing, Large Language Models",
      status: "current",
    },
    {
      name: "Fiifi Baffoe Payin Winful",
      title: "Teaching/Research Assistant",
      image: `${process.env.PUBLIC_URL}/payin.jpeg`,
      expertise:
        "Automatic Speech Recognition, Virtual Reality, Natural Language Processing, Large Language Models",
      status: "current",
    },
    {
      name: "Kafui Solaga",
      title: "Teaching/Research Assistant",
      image: `${process.env.PUBLIC_URL}/kafui.png`,
      expertise:
        "Automatic Speech Recognition, Virtual Reality, Natural Language Processing, Large Language Models",
      status: "current",
    },
  ],
};

export default teamData;
